import { useAtom } from "jotai";
import { PlanogramSidepanelTab } from "src/components/PlanogramExtensions/store/types";
import { omniAtom } from "src/utils/atoms";

const prefix = "planogramPanel";

export const planogramSidepanelTabsLockedAtom = omniAtom({
  prefix,
  key: "tabsLocked",
  value: false,
});

export const planogramSidepanelIsExpandedAtom = omniAtom({
  prefix,
  key: "isExpanded",
  value: true,
});

const planogramSidepanelTabAtom = omniAtom<PlanogramSidepanelTab>({
  prefix,
  key: "tab",
  value: "HIGHLIGHTS",
});

export const usePlanogramPanel = () => {
  const [isLocked] = useAtom(planogramSidepanelTabsLockedAtom);
  const [tab, setTab] = useAtom(planogramSidepanelTabAtom);

  const setTabSafe = (next: PlanogramSidepanelTab, overrideLock = false) => {
    if (isLocked && overrideLock === false) return;
    // `studioHistoryStore` survives unmount, so leaving the tab does not lose the session.
    setTab(next);
  };

  return { tab, setTab: setTabSafe };
};
